import { request } from '@/apis/request';

// 获取参数配置
export const fetchConfigSearch = async (configKey: string) => {
    const res: any = await request({
        method: 'post',
        url: '/eos-qmp-core-base/config/search',
        data: {
            configType: '1',
            configKey,
            pageNumber: 1,
            pageSize: 20
        }
    });
    const { items = [] } = res?.data || {};
    return items[0];
};